var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCriticalFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8,277.06V122.86c1.85-2.6,3.37-5.53,5.6-7.76Q64.18,64.42,115,13.93c2.24-2.22,5.17-3.75,7.78-5.6h154.5c2.7,1.93,5.73,3.54,8.06,5.85q50.52,50.2,100.83,100.64c2.32,2.32,3.92,5.34,5.86,8v154.2c-1.94,2.7-3.56,5.73-5.88,8.05Q335.6,335.77,284.94,386.28a17,17,0,0,1-13,5.38q-71.79-.2-143.59,0A17.79,17.79,0,0,1,114.8,386Q64.28,335.34,13.62,284.83C11.39,282.6,9.86,279.66,8,277.06Zm234.23-126.6c1-20.19,2.08-40.36,2.8-60.55.46-13.14-7.63-25-20.32-26.16a270,270,0,0,0-49.33,0C162.47,64.91,154.36,77,155,90.56q2.82,61.86,6.08,123.7c.59,11.49,9.95,22,21.52,23a205.67,205.67,0,0,0,32.55.38c14-.95,23.28-11.46,24-25.54ZM200,337.12a38.29,38.29,0,1,0-38.35-38.19A38.17,38.17,0,0,0,200,337.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.4,156.41c-.7,13.77-1.7,33.82-2.74,53.87-.22,4.23-1.27,5.22-5.51,5.25-7.5,0-15,0-22.5,0-3.53,0-5.18-1.42-5.35-5.09q-2.06-43.35-4.29-86.69c-.54-11-1.08-21.92-1.55-32.88-.2-4.85.65-5.69,5.58-5.71q16.86,0,33.74,0c5.14,0,6,.82,5.75,5.9C221.62,110.77,220.65,130.45,219.4,156.41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.85,298.9A15.86,15.86,0,1,1,200,283,15.66,15.66,0,0,1,215.85,298.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCriticalFill);
export default __webpack_public_path__ + "static/media/Icons_ Critical Fill.5f1ce8a2dc1c3cea4a70a61e8ac075e8.svg";
export { ForwardRef as ReactComponent };